import { updateFor } from "typescript";

export let qvCondTypes = [
   { "type": "like", name: "innehåller", "eq": true, "min": false, "max": false, "list": false, num: false, str: true, dt: false },
   { "type": "=", name: "=", "eq": true, "min": false, "max": false, num: true, str: true, dt: true },
   { "type": "bwn", name: "mellan", "min": true, "max": true, num: true, str: true, dt: true },
   { "type": ">=", name: ">=", "eq": false, "min": true, "max": false, num: true, str: true, dt: true },
   { "type": "<=", name: "<=", "eq": false, "min": false, "max": true, num: true, str: true, dt: true },
   { "type": ">", name: ">", "eq": false, "min": true, "max": false, num: true, str: true, dt: true },
   { "type": "<", name: "<", "eq": false, "min": false, "max": true, num: true, str: true, dt: true },
   { "type": "<>", name: "<>", "eq": true, "min": false, "max": false, num: true, str: true, dt: true },
   { "type": "empty", name: "(tom)", "eq": false, "min": false, "max": false, num: true, str: true, dt: true },
   { "type": "+-", name: "värde +-", "eq": false, "min": false, "max": false, num: true, str: false, dt: false },
   { "type": "in", name: "i lista", "eq": false, "min": false, "false": true, "list": true, num: true, str: true, dt: true },
   { "type": "!in", name: "ej i lista", "eq": false, "min": false, "max": false, "list": true, num: true, str: true, dt: true },
  
   { "type": "starts", name: "börjar på", "eq": true, "min": false, "max": false, "list": false, num: false, str: true, dt: false },
   { "type": "ends", name: "slutar på", "eq": true, "min": false, "max": false, "list": false, num: false, str: true, dt: false },
   { "bit" : "bit", name: "Ja/Nej", bit:true},
]

export class qvCondition {
   GetColType(columnType) {
      var ct = columnType.toLowerCase();
      if (ct.indexOf("date") >= 0) return "date";
      if (ct.indexOf("char") >= 0) return "text";
      if (
         ct.indexOf("int") >= 0 ||
         ct.indexOf("bigint") ||
         ct.indexOf("decimal") ||
         ct.indexOf("numeric")
      )
         return "numeric";
      if(ct.indexOf("bit"))
         return "bit";         
   };
   GetCondTypes(columnType) {
      if (columnType) {
         var ctype = this.GetColType(columnType);
         var res = qvCondTypes;
         switch (ctype) {
            case 'text':
               res = qvCondTypes.filter(x => x.str);
               break;
            case 'numeric':
               res = qvCondTypes.filter(x => x.num);
               break;
            case "date":
               res = qvCondTypes.filter(x => x.dt);
               break;
            case "bit":
               res = qvCondTypes.filter(x => x.bit);
            default:
               //cannot determine
               res = [];
         }
         return res;
      }
   };
   GetCondType(typeName) {
      var i = qvCondTypes.findIndex(x => x.type === typeName);
      if (i >= 0)
         return qvCondTypes[i];
   };

   GetFilter(cond) {
      //return JSON.stringify(cond);
      var fieldName = cond.field;
      var res = '';
      switch (cond.type) {
         case 'bwn':
         case '+-':
            if (cond.min && cond.max) return `[${fieldName}] between '${cond.min}' and '${cond.max}'`;
            if (cond.min && !cond.max) return `[${fieldName}] >= '${cond.min}'`;
            if (!cond.min && cond.max) return `[${fieldName}] <= '${cond.max}'`;
            break;
         case '=':
            return `[${fieldName}] = '${cond.eq}'`;
         case '>=':
            return `[${fieldName}] >= '${cond.min}'`;
         case '<=':
            return `[${fieldName}] <= '${cond.max}'`;
         case '>':
            return `[${fieldName}] > '${cond.min}'`;
         case '<':
            return `[${fieldName}] < '${cond.max}'`;
         case '<>':
            return `[${fieldName}]!='${cond.eq}'`;
         case 'empty':
            return `isnull([${fieldName}],'')=''`;
         case 'like':
            return `[${fieldName}]like'%${cond.eq}%'`;
         case 'starts':
            return `[${fieldName}]like'${cond.eq}%'`;
         case 'ends':
            return `[${fieldName}]like'%${cond.eq}'`;
         case 'in':
            if (cond.list && cond.list.length > 0) {
               var l = this.GetCommaList(cond.list);
               return `[${fieldName}] in (${l})`;
            }
            break;
         case '!in':
            if (cond.list && cond.list.length > 0) {
               var l = this.GetCommaList(cond.list);
               return `[${fieldName}] not in (${l})`;
            }
            break;
         case 'bit':
            return  `isnull([${fieldName}],0) in ('${cond.min},${cond.max}'`;
      }
   }
   GetCommaList(list) {
      return list.map(y => `'${y}'`).join(',');
   }

   IsFiltering(cond) {
      return this.GetFilter(cond) ? true : false;
   }

   CreateCondition(field, type, min, max) {

   }
}